<template>
  <div class="license_box">
    <table class="table table-bordered">
      <tbody>
      <template v-for="(item, index) in items">
        <tr>
          <td><label>{{item.itemKey}}</label></td>
        </tr>
        <tr>
          <td>{{item.itemValue}}</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "LicDetail",
  data() {
    return {
      items: []
    }
  },
  methods: {
    findDevLicense(neId) {
      const url = '/lte/ems/license/findLicenseInfo';
      let That = this;
      this.$axios.get(url, { params: { neId: neId }}).then(response => {
        That.items = response.data;
      })
    }
  }
}
</script>
<style scoped>
  .license_box{
    width: 70%;
    margin: 10px 15%;
  }
</style>
